import { API, graphqlOperation } from "aws-amplify";
import { MstMappingType } from "@/types/types";
import MakeInputBody from "./lib/make_input_body";

const mstMappingItems = `user_id
mapping_id
mst_signallamp_id
mst_graph_id
sensor_state
select_device_id`;

export default class MstMappingService {
  /**
   * ユーザーのマッピングマスター取得
   * @param userID
   */
  public static async queryAll(userID: string) {
    const queryAllBody: string = `
      query getAllMstMapping {
        queryAllIotKyotoMstMapping(user_id: "${userID}") {
          items {
            ${mstMappingItems}
          }
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(queryAllBody));
    const items: MstMappingType[] = result.data.queryAllIotKyotoMstMapping.items;
    if (typeof items === "undefined") {
      return null;
    } else {
      return MstMappingService.parseItems(items);
    }
  }

  /**
   * マッピングマスター作成
   * @param newMstMapping
   */
  public static async create(newMstMapping: MstMappingType) {
    const createBody: string = `
      mutation create {
        createIoTKyotoMstMapping(
          input: {
            ${MakeInputBody.makeMappingBody(newMstMapping)}
          }
        ) {
          ${mstMappingItems}
        }
      }
    `;
    await API.graphql(graphqlOperation(createBody));
    console.log("now");
  }

  /**
   * マッピングマスター更新
   * @param updateMstMapping
   */
  public static async update(updateMstMapping: MstMappingType) {
    const updateBody: string = `
      mutation update {
        updateIoTKyotoMstMapping(
          input: {
            ${MakeInputBody.makeMappingBody(updateMstMapping)}
          }
        ) {
          ${mstMappingItems}
        }
      }
    `;
    await API.graphql(graphqlOperation(updateBody));
  }

  public static async delete(userID: string, mappingID: number) {
    const deleteBody: string = `
      mutation delete {
        deleteIoTKyotoMstMapping(
          input: {
            user_id: "${userID}"
            mapping_id: ${mappingID}
          }
        ) {
          ${mstMappingItems}
        }
      }
    `;
    await API.graphql(graphqlOperation(deleteBody));
  }

  /**
   * sensorStateのparse
   * @param items
   */
  private static parseItems(items: MstMappingType[]) {
    items.map((item: MstMappingType) => {
      const sensorState: string = item.sensor_state as string;
      item.sensor_state = JSON.parse(sensorState);
    });
    return items;
  }
}
